export const BackToTop = require('./BackToTop.png');
export const Chatbot = require('./Chatbot.png');
export const ChatbotExpanded = require('./Chatbot_Expanded.png');

